<div class="azione-mitigatrice-evento">
  <div class="d-flex flex-column justify-content-center gap-2" style="width: 80%">
    <b class="panel-title" [title]="actionAssociata.azione.nome">{{ actionAssociata.azione.nome }}</b>
    <div class="d-flex align-items-center justify-content-start flex-wrap gap-3">
      <span>
        <mat-icon svgIcon="efficacia" [matTooltip]="'Efficacia'"></mat-icon>
        {{ actionAssociata.riduzione_probabilita }}%</span
      >
    </div>
  </div>

  <div class="d-flex align-items-center">
    <span>
      <mat-icon *ngIf="actionAssociata.stato === 2" color="primary" matTooltip="{{ 'map.sidebar.psa.risk_event.attacked_action.active' | translate }}"
        >check_circle</mat-icon
      >

      <mat-icon
        *ngIf="actionAssociata.stato === 1"
        color="primary"
        matTooltip="{{ 'map.sidebar.psa.risk_event.attacked_action.planned' | translate }}"
        >event_available</mat-icon
      >

      <mat-icon
        *ngIf="actionAssociata.stato === 0 || actionAssociata.stato === null"
        matTooltip="{{ 'map.sidebar.psa.risk_event.attacked_action.not_active' | translate }}"
        >block</mat-icon
      >
    </span>

    <button mat-icon-button [matMenuTriggerFor]="menuAction" (click)="$event.stopPropagation()" class="ml-auto center-horizontally">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menuAction="matMenu" class="menu-panel" (click)="$event.stopPropagation()">
      <button
        mat-menu-item
        class="w-100"
        [disabled]="actionAssociata.stato == 2"
        [matTooltip]="actionAssociata.stato == 2 ? ('map.sidebar.psa.risk_event.cannot_do_on_active_action' | translate) : ''"
        (click)="onEditRelEntityEventoRischioAzioneMitigatrice(actionAssociata)"
      >
        <mat-icon class="me-1" color="primary">edit</mat-icon>
        <span>{{ 'map.sidebar.psa.actions.edit_rel_action_event_entity' | translate }}</span>
      </button>

      <button
        mat-menu-item
        class="w-100"
        *ngIf="!!actionAssociata.stato"
        (click)="onChangeActionState(0)"
        [disabled]="eventoAssociato.lavorato"
        [matTooltip]="eventoAssociato.lavorato ? ('map.sidebar.psa.risk_event.cannot_do_on_worked_event' | translate) : ''"
      >
        <mat-icon class="me-1">block</mat-icon>
        <span>
          {{ 'map.sidebar.psa.risk_event.attacked_action.set_as_not_active' | translate }}
        </span>
      </button>

      <button
        mat-menu-item
        class="w-100"
        *ngIf="actionAssociata.stato !== 1"
        (click)="onChangeActionState(1)"
        [disabled]="eventoAssociato.lavorato"
        [matTooltip]="eventoAssociato.lavorato ? ('map.sidebar.psa.risk_event.cannot_do_on_worked_event' | translate) : ''"
      >
        <mat-icon class="me-1" [color]="eventoAssociato.lavorato ? '' : 'primary'">event_available</mat-icon>
        <span>
          {{ 'map.sidebar.psa.risk_event.attacked_action.set_as_planned' | translate }}
        </span>
      </button>

      <button
        mat-menu-item
        class="w-100"
        *ngIf="actionAssociata.stato !== 2"
        (click)="onChangeActionState(2)"
        [disabled]="eventoAssociato.lavorato"
        [matTooltip]="eventoAssociato.lavorato ? ('map.sidebar.psa.risk_event.cannot_do_on_worked_event' | translate) : ''"
      >
        <mat-icon class="me-1" [color]="eventoAssociato.lavorato ? '' : 'primary'">check_circle</mat-icon>
        <span>
          {{ 'map.sidebar.psa.risk_event.attacked_action.set_as_active' | translate }}
        </span>
      </button>

      <button
        mat-menu-item
        class="w-100"
        (click)="onDeleteAction(actionAssociata)"
        [disabled]="actionAssociata.stato == 2"
        [matTooltip]="actionAssociata.stato == 2 ? ('map.sidebar.psa.risk_event.cannot_do_on_active_action' | translate) : ''"
      >
        <mat-icon class="me-1" [color]="eventoAssociato.lavorato ? '' : 'warn'">remove</mat-icon>
        <span>{{ 'map.sidebar.psa.actions.delete' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>
